<template>
  <footer class="bg-transparent dark:bg-transparent shadow-none py-2 mt-auto">
    <div class="max-w-full px-4">
      <div class="flex justify-between items-center">
        <!-- Partie gauche avec logo ou vide -->
        <div class="flex items-center">
          <!-- Espace réservé pour un éventuel logo -->
        </div>
        
        <!-- Copyright au centre - visible uniquement sur desktop -->
        <div class="hidden md:block absolute left-1/2 transform -translate-x-1/2 text-sm text-gray-600 dark:text-gray-400">
          &copy; {{ currentYear }} K&C Madin Invest - Tous droits réservés
        </div>
        
        <!-- Copyright au centre - visible uniquement sur mobile -->
        <div class="md:hidden text-sm text-gray-600 dark:text-gray-400">
          &copy; {{ currentYear }}
        </div>
        
        <!-- Mentions légales à l'extrême droite -->
        <div class="flex-shrink-0 pr-2">
          <button 
            @click="isLegalModalOpen = true"
            class="hover:text-gray-900 dark:hover:text-white transition-colors cursor-pointer z-50 relative px-2 py-1 inline-block text-sm text-gray-600 dark:text-gray-400"
          >
            Mentions légales
          </button>
        </div>
      </div>
    </div>
    
    <!-- Modal des mentions légales -->
    <div v-if="isLegalModalOpen" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- Overlay de fond -->
        <div class="fixed inset-0 transition-opacity" @click="isLegalModalOpen = false">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- Modal -->
        <div class="inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 class="text-2xl font-bold mb-6 text-gray-800 dark:text-white">Mentions légales</h3>
                
                <div class="mb-6">
                  <h4 class="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">Propriété</h4>
                  <p class="mb-4 text-gray-600 dark:text-gray-400 text-justify">
                    Cette application est la propriété exclusive de K&C Madin Invest.
                  </p>
                  <p class="mb-4 text-gray-600 dark:text-gray-400">
                    <!-- Siège social : [Adresse du siège social]<br> -->
                    <!-- SIRET : [Numéro SIRET]<br> -->
                    Contact : ***************
                  </p>
                </div>
                
                <div class="mb-6">
                  <h4 class="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">Limitation de responsabilité</h4>
                  <p class="mb-4 text-gray-600 dark:text-gray-400 text-justify">
                    Les informations contenues dans cette application sont fournies à titre informatif uniquement. 
                    K&C Madin Invest ne peut garantir l'exactitude, la complétude ou la pertinence des informations 
                    mises à disposition dans le cadre de l'application.
                  </p>
                  <p class="mb-4 text-gray-600 dark:text-gray-400 text-justify">
                    Les décisions prises sur la base des informations fournies par l'application relèvent 
                    de la seule responsabilité de l'utilisateur. K&C Madin Invest ne pourra en aucun cas 
                    être tenue responsable des dommages directs ou indirects résultant de l'utilisation 
                    de ces informations.
                  </p>
                </div>
                
                <div class="mb-6">
                  <h4 class="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">Protection des données</h4>
                  <p class="mb-4 text-gray-600 dark:text-gray-400 text-justify">
                    Conformément à la législation en vigueur, l'utilisateur dispose d'un droit d'accès, 
                    de rectification et de suppression des données le concernant. Pour exercer ce droit, 
                    l'utilisateur peut contacter K&C Madin Invest à l'adresse indiquée ci-dessus.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button 
              @click="isLegalModalOpen = false" 
              type="button" 
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useLogger } from '@/utils/logger'

export default defineComponent({
  name: 'Footer',
  setup() {
    // Initialisation du logger pour ce composant
    const logger = useLogger('Footer')
    
    // Année courante pour le copyright
    const currentYear = ref(new Date().getFullYear())
    
    // État de la modal des mentions légales
    const isLegalModalOpen = ref(false)
    
    // Exécuté au montage du composant
    onMounted(() => {
      logger.debug('Footer component mounted')
    })
    
    return {
      currentYear,
      isLegalModalOpen
    }
  }
})
</script>

